import React from'react'
import styled from 'styled-components'
import {styles} from 'styles/values'

const StyledIcon = styled.svg``

export interface Props {
	d: string,
	width?: number,
	height?: number,
	color?: string,
}

const viewBox = '0 0 24 24'

const res = {
    /* eslint-disable */
    LOGO: 'M12 0A12 12 0 000 12a12 12 0 0012 12 12 12 0 0012-12A12 12 0 0012 0zm1 4.2a.39.39 0 01.1.01l3.19.71a1.26 1.26 0 11-.14.7l-2.88-.64-.97 4.2a9.06 9.06 0 015.22 1.73 1.85 1.85 0 012.84.23 1.8 1.8 0 01.1.17 1.92 1.92 0 01-.87 2.57 4.48 4.48 0 01-1.92 4.2 9.5 9.5 0 01-5.67 1.7 9.5 9.5 0 01-5.67-1.7 4.48 4.48 0 01-1.92-4.2 1.8 1.8 0 01-.18-.1 1.92 1.92 0 01-.59-2.64 1.98 1.98 0 01.22-.25 1.86 1.86 0 012.62.02 9.07 9.07 0 015.09-1.72l1.08-4.68a.39.39 0 01.36-.3zm-3.97 8.01a1.27 1.27 0 00-1.27 1.28 1.27 1.27 0 101.27-1.28zm5.94 0a1.27 1.27 0 00-1.27 1.28 1.27 1.27 0 101.27-1.28zM9.01 16.5a.3.3 0 00-.22.49 5.44 5.44 0 006.42 0 .3.3 0 00-.3-.48 4.96 4.96 0 01-5.81 0 .3.3 0 00-.09-.01z',
    SEARCH: 'M21.066 16.552c3.782-3.781 3.782-9.934 0-13.716-3.781-3.781-9.934-3.781-13.716 0-3.208 3.208-3.694 7.98-1.459 11.705 0 0 .16.27-.056.486L.887 19.976c-.985.985-1.22 2.362-.346 3.235l.15.15c.874.874 2.25.64 3.236-.345l4.937-4.938c.228-.227.497-.067.497-.067 3.726 2.235 8.497 1.75 11.705-1.459zm-11.925-1.79c-2.794-2.795-2.794-7.34 0-10.135 2.794-2.794 7.34-2.794 10.134 0 2.795 2.794 2.795 7.34 0 10.135-2.794 2.794-7.34 2.794-10.134 0zm.619-5.643a1 1 0 01-.922-1.392 6.309 6.309 0 018.26-3.347 1.001 1.001 0 01-.78 1.843 4.304 4.304 0 00-5.636 2.284 1.001 1.001 0 01-.922.612z',
    PLUS18: 'M7.6 16V9.6H6.1V7.9h3.6V16h-2zm9.8-6c0 .7-.4 1.3-1 1.7a2.2 2.2 0 011.4 2c0 1.5-1.3 2.4-3.3 2.4s-3.3-.9-3.3-2.3c0-1 .6-1.7 1.5-2.1a2 2 0 01-1-1.7c0-1.3 1-2.1 2.8-2.1 1.8 0 2.9.8 2.9 2.1zm-4.3 3.6c0 .6.5 1 1.4 1 .9 0 1.4-.3 1.4-1s-.5-1-1.4-1c-.9 0-1.4.3-1.4 1zm.2-3.5c0 .6.5 1 1.2 1 .8 0 1.2-.4 1.2-1s-.4-.9-1.2-.9c-.7 0-1.2.3-1.2 1zm8-1.2A9.8 9.8 0 0112 21.7 9.8 9.8 0 012.2 12a9.8 9.8 0 0113-9.3V.6A11.9 11.9 0 00.1 12c0 6.5 5.3 11.8 11.8 11.8a11.9 11.9 0 0011.4-15h-2.2zm-.7-5.6V1.1H19v2.2h-2.3V5H19v2.2h1.6V5H23V3.3z',
    /* eslint-enable */
}

const Icon = ({d, width = 24, height = 24, color}: Props) => (
    <StyledIcon
        viewBox={viewBox}
        aria-hidden='true'
        role='presentation'
        width={width}
        height={height}
    >
        <path d={d} fill={color || styles.color.shade.DARK} />
    </StyledIcon>
)
Icon.res = res

export default Icon